import React, { useRef, useEffect } from 'react';
import { useUpdateEffect } from 'ahooks';
import Polygon from './Polygon';
import { registerEventGeometry } from '../events';
import useProps from '../_util/useProps';

export default function(props) {
    const {data, property, style, label, position} = props;
    const featureRef = useRef();
    const { featureLayer } = useProps();

    useEffect(() => {
        let feature = new Polygon({
            geometry: data,
            style,
            properties: property,
            label,
            position
        });

        // 注册事件
        registerEventGeometry(feature, props);
        // 把featurelayer的可以赋值给多边形图元
        feature.key = featureLayer.key;
        featureLayer.entities.add(feature);

        featureRef.current = feature;

        return () => {
            featureLayer.entities.remove(feature);
        };
    }, []);

    useUpdateEffect(() => {
        featureRef.current.setGeometry(data);
    }, [JSON.stringify(data)]);

    useUpdateEffect(() => {
        featureRef.current.setPosition(position);
    }, [JSON.stringify(position)]);

    useUpdateEffect(() => {
        featureRef.current.setProperties(property);
    }, [JSON.stringify(property)]);

    useUpdateEffect(() => {
        featureRef.current.setLabel(label);
    }, [JSON.stringify(label)]);

    useUpdateEffect(() => {
        featureRef.current.setStyle(style);
    }, [style]);
    // ! 某些情况下 JSON.stringify(style) 会报错，比如 复杂的material

    return <></>;
}
